import { render } from "./HandleLabels.vue?vue&type=template&id=3c616758"
import script from "./HandleLabels.vue?vue&type=script&lang=js"
export * from "./HandleLabels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__